import { Button } from '@/components/shadcn/button'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { IconCloseOutline } from '@/components/icons'
import clsx from 'clsx'
import { FormFilterContent } from '../Filter'
import { Suspense } from 'react'

export function FiltersPanel({
  showFilters,
  toggleShowFilters,
  isConfiguringLayout,
}: {
  showFilters: boolean
  toggleShowFilters: () => void
  isConfiguringLayout: boolean
}) {
  return (
    <ScrollArea className="h-full">
      <div className={clsx('h-[calc(100vh-86px)] min-w-60 flex-col bg-white', { hidden: !showFilters })}>
        <div className="flex items-start justify-between p-3 text-lg font-medium">
          Filters
          <Button variant="ghost" className="size-5" size="icon" onClick={toggleShowFilters}>
            <IconCloseOutline className="size-4" />
          </Button>
        </div>
        <div className="flex flex-col gap-y-5 px-3 py-2">
          <div>
            <Suspense fallback={<div>Loading...</div>}>
              <FormFilterContent isConfiguringLayout={isConfiguringLayout} />
            </Suspense>
          </div>
        </div>
      </div>
    </ScrollArea>
  )
}
